import { Injectable, inject } from '@angular/core';
import { TicketService } from './ticket.service';
import { SnackbarService } from '../base/snackbar.service';
import { TranslationService } from '../base/translation.service';
import { TicketCloseRequest } from '../../models/Ticket/TicketCloseRequest';
import { getCurrentDateString } from '../../data';

@Injectable({ providedIn: 'root' })
export class TicketActionService {
  private readonly ticketService = inject(TicketService);
  private readonly snackbarService = inject(SnackbarService);
  private readonly translationService = inject(TranslationService);

  approve(
    ticketId: number,
    fieldId: number,
    fieldTypeId: number,
    approveValue: string,
    onSuccess: () => void,
    onError: () => void
  ): void {
    const request: TicketCloseRequest = {
      Id: ticketId,
      ClosingFieldTypeId: fieldTypeId,
      ClosingFields: [{ ClosingFieldId: fieldId, Value: approveValue }],
      CurrentDate: getCurrentDateString(),
    };

    this.ticketService.approveTicket(request).subscribe({
      next: (response) => {
        if (response?.Result === 'CC00FF') {
          this.snackbarService.success(this.translationService.instant('tickets.detail.approveSuccess'));
          onSuccess();
        } else {
          this.snackbarService.error(this.translationService.instant('tickets.detail.approveError'));
          onError();
        }
      },
      error: () => {
        this.snackbarService.error(this.translationService.instant('tickets.detail.approveError'));
        onError();
      },
    });
  }

  reject(
    ticketId: number,
    fieldId: number,
    fieldTypeId: number,
    rejectValue: string,
    onSuccess: () => void,
    onError: () => void
  ): void {
    const request: TicketCloseRequest = {
      Id: ticketId,
      ClosingFieldTypeId: fieldTypeId,
      ClosingFields: [{ ClosingFieldId: fieldId, Value: rejectValue }],
      CurrentDate: getCurrentDateString(),
    };

    this.ticketService.rejectTicket(request).subscribe({
      next: (response) => {
        if (response?.Result === 'CC00FF') {
          this.snackbarService.success(this.translationService.instant('tickets.detail.rejectSuccess'));
          onSuccess();
        } else {
          this.snackbarService.error(this.translationService.instant('tickets.detail.rejectError'));
          onError();
        }
      },
      error: () => {
        this.snackbarService.error(this.translationService.instant('tickets.detail.rejectError'));
        onError();
      },
    });
  }
}
